import axios from 'axios';
import { publicApiBaseUrl } from '../config';

export const publicRequest = axios.create({
  baseURL: publicApiBaseUrl,
});
